import React from 'react';
import messageCenterCommonStyles from 'MessageCenter/Common.module.css'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { diaryActions } from '_actions';

class DiaryTasksListItem extends React.Component {
    render() {
        return (
            <div
                className={
                    this.props.id === this.props.selectedMessage ? messageCenterCommonStyles.selected_message :
                        this.props.message.isRead === true ? messageCenterCommonStyles.read_message : messageCenterCommonStyles.unread_message
                }
                onClick={() => this.props.changeMessage(this.props.id)}>
                {this.props.message.patientName}
            </div>
        );
    }
}

function mapStateToProps(state, ownprops) {
    return {
        message: state.entities.mcDiaryItems[ownprops.id],
        selectedMessage: state.ui.mcDiaryItems.selectedMessage,
    };
}


function mapDispatchToProps(dispatch) {
    return {
        changeMessage: bindActionCreators(diaryActions.changeSelection, dispatch)
    };
}

const connectedDiaryTasksListItem = connect(mapStateToProps, mapDispatchToProps)(DiaryTasksListItem);
export { connectedDiaryTasksListItem as DiaryTasksListItem };